import { ReactNode, useEffect } from "react";

export default function MiniKitProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    console.log('✅ [MiniKitProvider] MiniKitProvider mounted, MiniKit initialization handled in main.tsx');
  }, []);

  return <>{children}</>;
}